import {concatPath, isNotEmpty} from "./CommonUtil";

export function url(path: string){
    if(isNotEmpty(path)){
        if(path.indexOf("http://") === 0 || path.indexOf("https://") === 0){
            return path;
        }else{
            return concatPath(getBaseUrl(), path);
        }
    }
    return path;
}

export function movePage(path:string){
    window.location.href = url(path);
}
// @ts-ignore
export function getUrlParamErrorCode(searchParams):string{
    if(searchParams != null && searchParams.size !== 0){
        const initErrorCode = searchParams.get("ec");
        if(isNotEmpty(initErrorCode)){
            return initErrorCode;
        }
    }
    return "";
}

export function getBaseUrl(){
    // @ts-ignore
    return _BASE_URL;
}